import { ShieldAlert } from "lucide-react";

/** Shown when someone without weekly diary access opens a Weekly Diary URL directly. */
const NoDiaryAccess = () => (
  <div className="wd-no-access" role="alert">
    <ShieldAlert size={32} />
    <h3>You don't have access to teachers' diaries</h3>
    <p>Only the principal and users with weekly diary access can review and approve weekly diaries.</p>
  </div>
);

export default NoDiaryAccess;
